import { trackersFactory } from "~/events/trackersFactory";

export const partnerEmailTrackerStem = "partner-onboarding-email-page";
const trackers = trackersFactory(partnerEmailTrackerStem);
const trackersAccountCreated = trackersFactory("partner-onboarding");

const submit = (): void => {
  trackers({ action: "submit-sign-up-cta" });
};

const submitSuccess = (): void => {
  trackersAccountCreated({
    action: "account_created",
    label: "Account Created",
  });
};

export const trackPartnerEmail = {
  submit,
  submitSuccess,
};
